<div class="c-gameChallenges">
  <div
    class="c-gameChallenges__icon"
    theming
    themingGroup="gamechallenges"
    themingAsset="logo"
    [themingOverride]="gameChallenge()?.assets">
    <slotcom-navigation-button
      type="close"
      (click)="closeModal()">
    </slotcom-navigation-button>

    @if (wallet) {
      <slotcom-wallet
        [type]="'Coins'"
        [animate]="true"></slotcom-wallet>
    }
  </div>

  <div
    class="c-gameChallenges__background"
    theming
    themingGroup="gamechallenges"
    themingAsset="background"
    [themingOverride]="gameChallenge()?.assets">
    @if (gameChallengeStatuses()!.redeemed) {
      <slotcom-box [classes]="['gameChallengesCompleted']">
        <span class="text completed">{{ 'home.live-ops.gamechallenges.completed' | translate | uppercase }}</span>
      </slotcom-box>
    }

    <div
      class="c-gameChallenges__container"
      theming
      themingGroup="gamechallenges"
      themingAsset="box"
      [themingOverride]="gameChallenge()?.assets">
      @if (gameChallengeStatuses()!.isGeneric) {
        <div
          class="c-gameChallenges__gameIcon no-pointer"
          theming
          themingGroup="tournament"
          themingAsset="generic-icon"
          [themingOverride]="gameChallenge()?.assets"></div>
      } @else {
        <div
          class="c-gameChallenges__gameIcon"
          [ngStyle]="gameIcon"
          avoidMulticlick
          (safeClick)="goToGame()"></div>
      }

      <div class="c-gameChallenges__text">
        <span class="text challengeText">
          {{ challengeText | uppercase }}
        </span>
      </div>

      <div class="c-gameChallenges__progress">
        @if (gameChallengeStatuses()!.minBet !== 0) {
          <span class="text minBet"
            >{{ 'home.live-ops.gamechallenges.min-stake-of' | translate }}
            {{ gameChallengeStatuses()!.minBet | number: '1.0-0' : ('common.culture' | translate) }}</span
          >
        }

        <slotcom-progress-bar
          [classes]="['c-progress-bar--green-black']"
          [currentProgress]="gameChallengeStatuses()!.current"
          [totalProgress]="gameChallengeStatuses()!.total"
          [completed]="gameChallengeStatuses()!.finished ? gameChallengeStatuses()!.finished : true">
          <span class="text percent">
            {{
              gameChallengeStatuses()!.current < gameChallengeStatuses()!.total
                ? (gameChallengeStatuses()!.current | notRoundingBeautifyNumber: ('common.culture' | translate)) +
                  ' / ' +
                  (gameChallengeStatuses()!.total | notRoundingBeautifyNumber: ('common.culture' | translate))
                : ('home.live-ops.gamechallenges.completed-2' | translate | uppercase)
            }}
          </span>
        </slotcom-progress-bar>
      </div>

      <div
        class="c-gameChallenges__reward"
        [ngClass]="gameChallengeStatuses()!.redeemed ? 'less-brightness' : ''">
        <span class="text reward-text">{{ 'home.live-ops.gamechallenges.reward' | translate | uppercase }}</span>
        <slotcom-display [classes]="['c-display--gameChallenges']">
          <div
            displayIcon
            displayIconPos="left"
            class="c-display--coin"></div>
          <span class="text reward">{{
            gameChallengeStatuses()!.reward?.credits | beautifyNumber: ('common.culture' | translate)
          }}</span>
        </slotcom-display>
        @if (gameChallengeStatuses()!.finished && gameChallengeStatuses()!.redeemed) {
          <div class="e-checkIcon"></div>
        }

        @if (!gameChallengeStatuses()!.redeemed) {
          <slotcom-button
            class="c-button--pink"
            (safeClick)="manageRedeem()"
            [isLoading]="isRedeeming()"
            audioType="functionality">
            @if (!gameChallengeStatuses()!.finished) {
              {{
                (gameChallenge()?.statusCultureButtonText[lang]
                  ? gameChallenge()?.statusCultureButtonText[lang]
                  : ('common.play' | translate)
                ) | uppercase
              }}
            } @else {
              {{ 'common.collect' | translate | uppercase }}
            }
            <ng-template #completed>
              {{ 'common.collect' | translate | uppercase }}
            </ng-template>
          </slotcom-button>
        }
      </div>

      <div class="c-gameChallenges__timer">
        @if (showTimer()) {
          <div>
            <span class="text">{{ 'home.live-ops.global.time-left' | translate }}</span>
            <slotcom-animated-timer
              [showInDays]="true"
              [endDate]="gameChallenge()!.endDate"
              (expired)="closeModal()"></slotcom-animated-timer>
          </div>
        }
      </div>
    </div>
  </div>
</div>
